// Copyright (c) 2017 PlanGrid, Inc.

import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../fileViewerMessages';

const UnsupportedViewer = () => (
  <div className="pg-driver-view">
    <div className="unsupported-message">
      <p className="alert">
        <b>
          <FormattedMessage {...messages.NoPreviewAvailableForThisDocument} />
        </b>
      </p>
    </div>
  </div>
);

export default UnsupportedViewer;
